import React from 'react';
import { withRouteProps } from 'src/app/hocs/withRouteProps';

// Layout
import { SettingsLayout } from 'src/components/Layout';

// Providers
import { AircraftMappingsProvider } from '../containers/AircraftMappings/providers';

// Types
import { TUpdateUrl } from 'src/app/props';
import { AircraftMappingsContainer } from '../containers/AircraftMappings/AircraftMappings';

const Screen = ({ updateUrl }: { updateUrl: TUpdateUrl }) => (
  <SettingsLayout>
    <AircraftMappingsProvider>
      <AircraftMappingsContainer updateUrl={updateUrl} />
    </AircraftMappingsProvider>
  </SettingsLayout>
);

export const AircraftMappingsScreen = withRouteProps(Screen);
